import { ActivityCard, type ItineraryItem } from "./ActivityCard";
import { groupItemsBySection } from "@/lib/itinerarySections";
import { isOngoingProgramme } from "@/lib/ongoingProgrammes";
import { SessionBreakdown } from "./SessionBreakdown";

interface ProgrammeSectionsProps {
  items: ItineraryItem[];
  sections?: unknown;
}

export function ProgrammeSections({ items, sections }: ProgrammeSectionsProps) {
  return (
    <div className="space-y-8">
      {groupItemsBySection(items, sections).map((group) => (
        <section key={group.name} className="overflow-hidden rounded-lg border bg-background">
          <div className="bg-secondary px-6 py-4 text-secondary-foreground">
            <h3 className="text-xl font-bold">{group.name}</h3>
            <p className="text-sm text-secondary-foreground/80">
              {group.items.length} programme element{group.items.length === 1 ? "" : "s"}
            </p>
          </div>
          <div className="space-y-4 p-4">
            {group.items.map((item) => (
              <div key={item.id} className="space-y-2">
                <ActivityCard item={item} />
                {isOngoingProgramme(item as any) && <SessionBreakdown item={item} />}
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}